module.exports = "https://www.gc-qa.gnp.com.mx/9d81699c13d64f956131a36ef6c9f29b.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/instagram.png
// module id = 8142
// module chunks = 0